/**
 * Lightweight, fire-and-forget product engagement tracker.
 *
 * Sends an event to POST /api/analytics/product-event without blocking the
 * UI. Used by:
 *   - Product detail page mount  → 'view'
 *   - Cart context addToCart      → 'add_to_cart'
 *   - Checkout / invoice submit   → 'quote_request'
 *
 * The backend feeds these into the data-driven "Most Requested" homepage
 * rail. Failures are intentionally silent — analytics must never break the
 * shopping flow.
 */
import { trackClarityEvent } from './clarity';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const CLARITY_EVENT_NAMES = { view: 'product_view', add_to_cart: 'add_to_cart', quote_request: 'quote_request' };

export const trackProductEvent = (catNo, type) => {
  if (!catNo || !type) return;
  if (CLARITY_EVENT_NAMES[type]) trackClarityEvent(CLARITY_EVENT_NAMES[type], { product_code: catNo });
  try {
    // Use sendBeacon when available for fire-and-forget reliability on
    // navigation. Falls back to fetch keepalive otherwise.
    const body = JSON.stringify({ catNo, type });
    if (typeof navigator !== 'undefined' && navigator.sendBeacon) {
      const blob = new Blob([body], { type: 'application/json' });
      navigator.sendBeacon(`${API_URL}/api/analytics/product-event`, blob);
      return;
    }
    fetch(`${API_URL}/api/analytics/product-event`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true,
    }).catch((e) => console.debug('product-event beacon failed:', e));
  } catch (e) {
    // never surface analytics errors to the user
    console.debug('product-event tracking error:', e);
  }
};
